import { render } from "./AtomAccordion.vue?vue&type=template&id=4a01ac2c&scoped=true&ts=true"
import script from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomAccordion.vue?vue&type=script&lang=ts&setup=true"

import "./AtomAccordion.vue?vue&type=style&index=0&id=4a01ac2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a01ac2c"],['__file',"src/components/atoms/AtomAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a01ac2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a01ac2c', __exports__)) {
    api.reload('4a01ac2c', __exports__)
  }
  
  module.hot.accept("./AtomAccordion.vue?vue&type=template&id=4a01ac2c&scoped=true&ts=true", () => {
    api.rerender('4a01ac2c', render)
  })

}


export default __exports__